import { CmsContentTypeEnum, SectionNameEnum } from '@app/enums';

export const CMS_CONTENT_TYPE_TO_SECTION_MAP: Record<string, SectionNameEnum> = {
    [CmsContentTypeEnum.HERO]: SectionNameEnum.HeroSection,
    [CmsContentTypeEnum.PROMOTED_DESTINATIONS]: SectionNameEnum.DestinationSuggestionsSection,
    // [CmsContentTypeEnum.FEATURED_ACCOMMODATION]: SectionNameEnum.FeaturedAccommodationsSection,
    // etc.
};
